import React from 'react';

interface CardProps {
    id?: string;
    className?: string;
    children?: React.ReactNode;
    header?: React.ReactNode;
    title?: React.ReactNode;
    tabIndex?: number;
}
function Card({ className, children, header, title, tabIndex, id }: CardProps) {
    return (
        <div className={`card ${className || ''}`} tabIndex={tabIndex} id={id}>
            {title && (
                <div className="card-header">
                    <div className="h4">{title}</div>
                </div>
            )}
            {header && header}
            <div className="card-body">{children}</div>
        </div>
    );
}

export { Card };
